import { type JSX, memo } from 'react';

import { type CategoryGroup } from '@cx-modules/constants';
import { useTranslation } from '@cx-modules/i18n-provider';

import { useMatchesCouponContext } from '../../hooks';
import { type HomeOrAway, type Team } from '../../types';
import { BadgePlaceholder } from '../placeholders/BadgePlaceholder';

import { DesktopOnlyText, MobileOnlyText, TeamBadge, TeamWrapper } from './style';

type TeamProps = {
  categoryGroup?: CategoryGroup;
  hierarchyName: string;
  showTeamBadges: boolean;
  team?: Team;
} & HomeOrAway;

const TeamInfo = ({ categoryGroup, hierarchyName, home, showTeamBadges, team }: TeamProps): JSX.Element => {
  const { t } = useTranslation(categoryGroup?.translationFile || 'label');
  const translateBetNames = useMatchesCouponContext(state => state.translateBetNames);

  const isHome = Boolean(home);

  const teamBadge = showTeamBadges ? (
    <TeamBadge>
      {team?.badgeUrl ? <img alt={`${team?.name} logo`} src={team?.badgeUrl} /> : <BadgePlaceholder />}
    </TeamBadge>
  ) : null;

  const desktopName = translateBetNames ? t(hierarchyName) : team?.name;
  const mobileName = translateBetNames ? t(hierarchyName) : team?.nickName || team?.name;

  return (
    <TeamWrapper>
      {teamBadge}
      <p>
        {isHome && '@ '}
        <DesktopOnlyText data-testid="team-name-desktop">{desktopName}</DesktopOnlyText>
        <MobileOnlyText data-testid="team-name-mobile">{mobileName}</MobileOnlyText>
      </p>
    </TeamWrapper>
  );
};

export default memo(TeamInfo);
